import { useSelector } from 'react-redux';
import { getLotteryIdentifiers } from 'core/ducks/lottery';
import { LotteryType } from 'core/interfaces';
import { IStore } from 'store/interface';

export const useLotteryIdentifiers = (type: LotteryType) => ({
  identifiers: useSelector<IStore, number[]>(getLotteryIdentifiers(type)),
});
